import { createSlice } from '@reduxjs/toolkit';
import { InventoryFetchSuccessAction, InventoryState } from './inventory.types';
import { createSliceHook, makeActionCreator } from '../helpers';

const initialState: InventoryState = {
  loading: false,
  error: undefined,
  inventory: {
    sponsors: [],
    therapeuticAreas: [],
    phases: [],
    diseases: [],
    locations: [],
  },
};

const { actReq, actReject, actResolve } = makeActionCreator<InventoryState>();

export const inventorySlice = createSlice({
  name: 'inventory',
  initialState,
  reducers: {
    fetchInventory: actReq(),
    fetchInventorySuccess:
      actResolve<InventoryFetchSuccessAction['payload']>('inventory'),
    fetchInventoryFailure: actReject('error'),
  },
});

export const { fetchInventory, fetchInventorySuccess, fetchInventoryFailure } =
  inventorySlice.actions;

export const actions = {
  ...inventorySlice.actions,
};

export const useInventorySlice = createSliceHook(inventorySlice.name, actions);
